import Talk from './Talk'
export default Talk